import config from "config";
import axios from "axios";

const ROOT = config.API_BASE_URL;

class DeviceInventoryService {
    static getAvailableInventory(serialNumberScanType) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${ROOT}fleets/inventory/installable?serialNumberScanType=${serialNumberScanType}`)
                .then((data) => {
                    resolve({ availableInventory: data.data, response: data });
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    static getInventoryData(inventoryId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${ROOT}fleets/inventory/${inventoryId}`)
                .then((data) => {
                    resolve({ inventoryData: data.data, response: data });
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
}

export default DeviceInventoryService;
